import React from "react";
import { useTranslation } from "react-i18next";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import LanguageIcon from "@mui/icons-material/Language";
import SvgIcon from "@mui/material/SvgIcon";
import Grid from "@mui/material/Grid";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";

const CustomInput = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-root": {
    borderRadius: 8,
  },
}));

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  return (
    <div style={{ width: "min-content" }}>
      <Select
        className="language_selector"
        sx={{
          "&::before": {
            border: "1px solid white",
          },
          "&:hover": {
            "&& fieldset": {
              border: "1px solid white",
            },
          },
          "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid black",
            borderRadius: "5px 5px 0 0",
          },
        }}
        renderValue={(value) => {
          return (
            <Box
              sx={{
                display: "inline-flex",
                gap: 1,
              }}
              paddingTop={{ xs: "0.5rem", md: "0.3rem" }}
              paddingRight="1.3rem"
              paddingLeft={{ xs: "1rem", md: "0rem" }}
            >
              <SvgIcon color="white" style={{ paddingTop: "0.125rem" }}>
                <LanguageIcon />
              </SvgIcon>

              {value === "en" ? "English" : "Español"}

              <Grid width={{ xs: "1rem", md: "0rem" }}></Grid>
            </Box>
          );
        }}
        value={i18n?.resolvedLanguage || "es"}
        onChange={(e) => {
          i18n.changeLanguage(e.target.value);
          window.location.reload();
        }}
        input={<CustomInput />}
        MenuProps={{
          PaperProps: {
            sx: {
              width: "2rem !important",
              height: "11rem !important",
              "& .MuiMenuItem-root": {
                padding: 1.5,
              },
            },
          },
        }}
      >
        <MenuItem value="es">Español</MenuItem>
        <MenuItem value="en">English</MenuItem>
      </Select>
    </div>
  );
};
